import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TemplateStatus } from '../../shared/dto/request/template-config.request';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  siteId: string = '';
  templateStatus: string = "RELEASE";
  constructor(private store: Store, private route: ActivatedRoute, private translate: TranslateService) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const headers: { [key: string]: string } = {};
    if (this.route.snapshot.queryParams['template-status']) {
      this.templateStatus = this.route.snapshot.queryParams['template-status'];
      headers['template-status'] = this.templateStatus;
    }


    if (this.route.snapshot.queryParams['site-id']) {
      this.siteId = this.route.snapshot.queryParams['site-id'];

    } else {
      this.siteId = this.store.selectSnapshot(
        (state) => state.templateConfig.site_id,
      );
    }

    if (this.siteId) {
      headers['site-id'] = this.siteId;
    }

    // Idioma de CONTENIDO del cliente = idioma de UI activo (@ngx-translate). El backend lo
    // resuelve por Accept-Language (título/descripción/variantes ya traducidos, y snapshot de
    // idioma en carrito/checkout/order). Ausente → el backend cae a defaultValue (retrocompat).
    const contentLang = this.translate.currentLang;
    if (contentLang) {
      headers['Accept-Language'] = contentLang;
    }

    if (req.url.includes('assets/')) {
      return next.handle(req);
    }

    const modifiedRequest = req.clone({
      setHeaders: headers,
    });
    return next.handle(modifiedRequest);

  }
}
